module.exports = __webpack_public_path__ + "static/media/chart-bar.371710b0.svg";